// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"895":"d8957a4b","8412":"0dfde970","8549":"eac6f245"}[chunkId] + ".chunk.css";
};